import { jsx as r, jsxs as s, Fragment as y } from "react/jsx-runtime";
import { SwitchPrimitive as T } from "./index.es584.js";
import { BodyText as N } from "./index.es487.js";
import { forwardRef as S, cloneElement as g } from "react";
import e from "./index.es585.js";
import { removeSpaces as u } from "./index.es586.js";
import { TinyText as C } from "./index.es493.js";
import { LockIcon as E } from "./index.es295.js";
const $ = "switch-component", M = S(
  ({
    title: i,
    description: t,
    label: o,
    disabled: n,
    RightIcon: h,
    defaultChecked: m,
    isLocked: c,
    onCheckedChange: f,
    checked: a = !1,
    testId: l = $,
    role: p = "switch",
    ...v
  }, b) => {
    const d = !!t, w = a || m, x = u(`switch-label-${i}`);
    return !o && !i && !t ? /* @__PURE__ */ r(
      T,
      {
        theme: e,
        ref: b,
        disabled: n,
        defaultChecked: m,
        checked: a,
        onCheckedChange: c ? void 0 : f,
        testId: l,
        "aria-checked": a,
        role: p,
        ...v
      }
    ) : /* @__PURE__ */ s("div", { className: e.titleContainer, children: [
      i && /* @__PURE__ */ r("label", { id: x, className: e.label, children: i }),
      /* @__PURE__ */ s("div", { className: e.item, role: p, children: [
        /* @__PURE__ */ r(
          T,
          {
            theme: e,
            "aria-labelledby": x,
            ref: b,
            disabled: n,
            defaultChecked: m,
            checked: a,
            testId: l,
            onCheckedChange: c ? void 0 : f,
            role: "switch",
            "aria-checked": a,
            ...v
          }
        ),
        o && /* @__PURE__ */ s("span", { className: e.labelsContainer, children: [
          /* @__PURE__ */ s("div", { className: e.texts, "data-testid": `${l}-label`, children: [
            /* @__PURE__ */ r(
              N,
              {
                variant: w ? "bold" : d ? "semi-bold" : "regular",
                element: "label",
                color: n ? "disabled" : "secondary",
                children: w ? o.on : o.off
              }
            ),
            d && h && (/* @__PURE__ */ r(y, { children: g(h, { size: 16 }) }) || /* @__PURE__ */ r(y, {}))
          ] }),
          d && /* @__PURE__ */ r(
            "span",
            {
              className: e.texts,
              "data-testid": `${l}-description`,
              children: /* @__PURE__ */ r(
                C,
                {
                  variant: "address",
                  color: n ? "disabled" : "secondary",
                  children: t
                }
              )
            }
          )
        ] }),
        c && /* @__PURE__ */ r(E, { color: "gray", size: 16 })
      ] })
    ] });
  }
);
export {
  $ as SWITCH_DEFAULT_TESTID,
  M as Switch
};
//# sourceMappingURL=index.es117.js.map
